"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const arrow_right_1 = require("../icons/arrow-right");
exports.default = arrow_right_1.ArrowRight;
